import { useCallback } from "react";
import { FiCalendar } from "react-icons/fi";
import { usePatientAppointmentICS } from "src/hooks/patients/usePatientAppointmentICS";
import { logDev } from "src/utils";

interface IProps {
    appointmentId: number;
    message?: { text?: string; className?: string };
    icon?: {
        size?: string;
        className?: string;
    };
    buttonClassName?: string;
    isInRow?: boolean;
}

const AppointmentCalendarICS: React.FC<IProps> = ({
    appointmentId,
    message,
    icon,
    buttonClassName,
    isInRow,
}) => {
    const [ref, , getICSFile] = usePatientAppointmentICS();

    const handleDownloadICSFile = useCallback(() => {
        if (!appointmentId) {
            logDev("Can't get ICS file - no appointment id");
            return;
        }
        logDev("Getting ICS File");
        getICSFile(appointmentId);
    }, [appointmentId, getICSFile]);

    return (
        <div className={buttonClassName}>
            <a ref={ref} className="invisible" />

            <div
                className={`d-flex justify-content-center align-items-center flex-${
                    isInRow ? "row" : "column"
                }`}
                onClick={handleDownloadICSFile}
            >
                <FiCalendar
                    className={`pointer blue ${icon?.className || ""}`}
                    size={icon?.size || "1.5em"}
                />
                <span
                    className={
                        message?.className
                            ? message.className
                            : "badge text-bg-primary lg p-1 mt-1 body-xsmall"
                    }
                >
                    {message?.text ? message.text : "save to cal"}
                </span>
            </div>
        </div>
    );
};

export default AppointmentCalendarICS;
